import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import Text from '../../atoms/Text';
import Dialog from '../../molecules/Dialog';

import styles from './index.pcss';
import properties from '../../../modules/ajio-util/properties';
import { getRateCalculateText } from '../../selectors/featureFlagsSelector';

const cx = classNames.bind(styles);

interface RateCalculationPopupProps {
  visible: boolean;
}

const mapStateToProps = state => {
  return {
    rateCalculateText: getRateCalculateText(state)
  };
};
const connector = connect(mapStateToProps);

const RateCalculationPopup: FC<RateCalculationPopupProps> = (props: RateCalculationPopupProps) => {
  const { visible, onClose, isDesktop, rateCalculateText, isFleek = false } = props;
  const imageBaseUrl: string = properties.getProperty('imageBaseUrl');
  const ratingCalculationPopup = `${imageBaseUrl}/static/img/rating-calculation-popup.svg`;

  return (
    <section
      id='rate-calculation-popup'
      style={{ position: 'absolute', left: '173px', height: '100px', bottom: '52px', zIndex: '5' }}
    >
      {isDesktop ? (
        // {visible && (
        <div className="popupRatingCalculation" style={{ margin: '3%', position: 'relative' }}>
          <img
            src={ratingCalculationPopup}
            alt="Background"
            aria-hidden="true"
            style={{ width: '367px', height: '136px', objectFit: 'contain' }}
          />
          <p
            style={{
              position: 'absolute',
              top: '17px',
              left: '20px',
              width: '216px',
              height: '20px',
              fontSize: '16px',
              fontWeight: 'bold',
              textAlign: 'center',
              color: '#202020'
            }}
          >
            How are Ratings Calculated
          </p>
          <p
            style={{
              position: 'absolute',
              top: '17px',
              left: '20px',
              width: '327px',
              height: '51px',
              margin: '32px 0 0',
              fontSize: '12px',
              lineHeight: '1.5',
              textAlign: 'left',
              color: '#6d6d6d'
            }}
          >
            {rateCalculateText}
          </p>
        </div>
      ) : (
        <Dialog
          type="drawer"
          showDialog={visible}
          onCancel={onClose}
          customContentClass={isFleek ? 'fleek-reviews-dialog' : ''}
          ariaLabel="How are Ratings Calculated"
        >
          <div
            className="popupRatingCalculation"
            style={{
              padding: '6.5px 20px 16px 16px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              overflow: 'hidden',
              marginTop: '20px',
              paddingRight: '15px',
              paddingLeft: '16px'
            }}
          >
            <p
              style={{
                width: '100%',
                height: '20px',
                fontFamily: 'Muli',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              How are Ratings Calculated
            </p>
            <p
              style={{
                width: '100%',
                height: '51px',
                margin: '16px 0 0',
                fontFamily: 'Muli',
                fontSize: '12px',
                lineHeight: '1.5',
                textAlign: 'left'
              }}
            >
              {rateCalculateText}
            </p>
            <div
              className="Rectangle-4264"
              style={{
                width: '100%',
                height: '48px',
                margin: '24px 0 0 4px',
                borderRadius: '8px',
                backgroundColor: isFleek ? '#EBFF00' : '#202020',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              onClick={onClose}
            >
              <span
                className="Okay"
                style={{
                  width: '36px',
                  height: '18px',
                  fontFamily: 'Muli',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  lineHeight: '1.57',
                  letterSpacing: '0.42px',
                  textAlign: 'center',
                  color: isFleek ? '#060C10' : '#fff'
                }}
              >
                Okay
              </span>
            </div>
          </div>
        </Dialog>
      )}
    </section>
  );
};

export default connector(RateCalculationPopup);
